import { jsx as _jsx } from "react/jsx-runtime";
import { assertContext } from '@bos/utils';
import { createContext, useContext } from 'react';
const mobilityUiConfigContext = createContext(null);
export const MobilityUiProvider = ({ children, config, }) => {
    return (_jsx(mobilityUiConfigContext.Provider, { value: config, children: children }));
};
export const useMobilityUiConfig = () => {
    const context = useContext(mobilityUiConfigContext);
    assertContext(context, 'mobilityUiConfigContext');
    return context;
};
